import { Fragment, memo } from 'react';

import LoginWaves from '../../../../../assets/images/LoginWaves.svg';
import ManRunning from '../../../../../assets/images/ManRunning.svg';
import WomanStaring from '../../../../../assets/images/WomanStaring.svg';
import * as styles from './LoginFooter.styles';

const LoginFooterBase = () => {
  return (
    <Fragment>
      <div css={styles.illustrations}>
        <div css={styles.manRunning}>
          <svg width={260} height={225}>
            <ManRunning />
          </svg>
        </div>
        <div css={styles.womanStaring}>
          <svg width={190} height={208}>
            <WomanStaring />
          </svg>
        </div>
      </div>
      <div css={styles.waves}>
        <LoginWaves />
      </div>
    </Fragment>
  );
};

export const LoginFooter = memo(LoginFooterBase);
